import React from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { BaseLoginScreen } from "../Login/BaseLoginScreen";
import { Route } from "react-router";
import { Search } from "./Search";
import { RegContextWrapper } from "./ctx";
import { Forms } from "./Form";

export default function Registrations( props: RoutedViewProps ) {
	const pp = props.match.url;
	return <RegContextWrapper>
		<BaseLoginScreen containerClass="auth-register-container">
			<Route path={ pp + "/" } exact={ true } component={ Search }/>
			<Route path={ pp + "/forms" } component={ Forms }/>
		</BaseLoginScreen>
	</RegContextWrapper>;
}
